var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form-sect"},[(_vm.title)?_c('div',{staticClass:"title"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),(_vm.sub)?_c('div',{staticClass:"sub"},[_vm._v("\n      "+_vm._s(_vm.sub)+"\n    ")]):_vm._e()]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36e7dd88","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/globals/FormSect.vue
// module id = 395
// module chunks = 8